import { graphql } from '@mp/graphql/generated';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';
import { type ResultOf } from '@graphql-typed-document-node/core';

const PositionsGql = graphql(`
  query GetCurrentUserForPositions($id: Int!, $location_ids: [Int!]!) {
    me {
      professional {
        professional_positions {
          position_id
          years_of_experience
        }
        specialties {
          id
        }
      }
    }
  }
`);

export const useUserPositions = () => {
  const { data, isLoading: currentUserLoading } = useGraphQLQuery<ResultOf<typeof PositionsGql>>({
    operationName: 'GetCurrentUserForPositions',
    query: PositionsGql,
    variables: {},
  });

  const currentUser = data?.me;

  return {
    currentUser,
    currentUserLoading,
  };
};
